
import { IAgentSignup, PasswordCreationRulesText, SignupFactory } from '@tokyojob/core'
import {
  AgreementLabel,
  AgreementRoute,
  Button,
  ButtonFactory,
  CButton,
  CCheckbox,
  Checkbox,
  CheckboxFactory,
  CTextInput,
  ITextInput,
  PasswordRules,
  TextInputFactory,
  InputFieldType
} from '@tokyojob/frontend-components'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Vue from 'vue'

const companyTextInput = TextInputFactory.LargeTextInputRequired({
  label: '会社名',
  placeholder: '株式会社　エージェント',
  showAsterisk: false,
  css: 'btn-lg theme-shades-medium2-white'
})
const accountTextInput = TextInputFactory.LargeTextInputRequired({
  label: 'メール',
  placeholder: 'agent@theagent.co.jp',
  showAsterisk: false,
  validation: {
    required: true,
    email: true
  },
  css: 'btn-lg theme-shades-medium2-white'
})

const passwordTextInput = TextInputFactory.LargeTextInputRequired({
  label: 'パスワード',
  placeholder: '**********',
  type: InputFieldType.Password,
  validation: PasswordRules,
  showAsterisk: false,
  css: 'btn-lg theme-shades-medium2-white'
})
const signupButton = ButtonFactory.button({
  label: '新規登録',
  classes: 'btn-lg theme-yellow-medium1-color row-center-fullwidth align-center'
})

interface IData {
  newAccountCredentials: IAgentSignup
  companyTextInput: ITextInput
  accountTextInput: ITextInput
  passwordTextInput: ITextInput
  passwordCreationRulesText: string
  privacyPolicyCheckbox: Checkbox
  signupButton: Button
  termsCheckbox: boolean
  policyLinkButton: Button
  agreementLinkButton: Button
}
export default Vue.extend({
  components: { ValidationProvider, ValidationObserver, CButton, CTextInput, CCheckbox },
  props: {
    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data(): IData {
    const privacyPolicyCheckbox = CheckboxFactory.defaultCheckbox({ name: '利用規約とプライバシーポリシー契約', required: true })
    const policyLinkButton = ButtonFactory.textOnlyLinkBlueUnderline({
      label: AgreementLabel.AgentPolicy,
      link: { link: AgreementRoute.Agent, router: this.$router }
    })
    const agreementLinkButton = ButtonFactory.textOnlyLinkBlueUnderline({
      label: AgreementLabel.AgentAgreement,
      link: { link: AgreementRoute.Agent, router: this.$router }
    })
    return {
      newAccountCredentials: SignupFactory.Agent(),
      companyTextInput: companyTextInput,
      accountTextInput: accountTextInput,
      passwordTextInput: passwordTextInput,
      passwordCreationRulesText: PasswordCreationRulesText.JAjp,
      privacyPolicyCheckbox,
      signupButton: signupButton,
      termsCheckbox: false,
      policyLinkButton,
      agreementLinkButton
    }
  },
  watch: {
    $route() {
      this.newAccountCredentials = SignupFactory.Agent()
    }
  },
  methods: {
    async submit(validate: Function) {
      if (!(await validate())) return
      this.$emit('submit', this.newAccountCredentials)
    }
  }
})
